import { WS_METHODS } from "@cmmd-forge/contracts";

import type { WsTransport } from "./wsTransport";

export async function cancelWorkspaceFileWrite(
  transport: WsTransport,
  transferId: string,
): Promise<void> {
  await transport
    .request((client) => client[WS_METHODS.workspaceCancelWriteFile]({ transferId }))
    .catch(() => undefined);
}
